import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { TUserSettingEditForm } from "@/features/user-setting/types/userSettingEditForm";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Control } from "react-hook-form";

type TPasswordResetFieldsProps = {
  control: Control<TUserSettingEditForm>;
  hasPassword: boolean;
};

export const PasswordResetFields: FC<TPasswordResetFieldsProps> = ({ control, hasPassword }) => (
  <Stack gap="16px">
    <Typography variant="sub16Semi" color={text.primary}>
      パスワードの再設定
    </Typography>

    <Stack direction="row" gap="24px" flexWrap="wrap">
      <Stack flex={1} minWidth="240px">
        <FormField control={control} name="currentPassword">
          <Input type="password" placeholder={hasPassword ? "入力してください" : ""} disabled={!hasPassword} />
        </FormField>
      </Stack>
      <Stack flex={1} minWidth={0} />
    </Stack>

    <Stack direction="row" gap="24px" flexWrap="wrap">
      <Stack flex={1} minWidth="240px">
        <FormField control={control} name="newPassword">
          <Input type="password" placeholder="入力してください" />
        </FormField>
      </Stack>
      <Stack flex={1} minWidth="240px">
        <FormField control={control} name="confirmNewPassword">
          <Input type="password" placeholder="入力してください" />
        </FormField>
      </Stack>
    </Stack>
  </Stack>
);
